export const SERVICE_ACCESS_PIN_STORAGE_KEY = 'serviceAccessPin'
export const SERVICE_ACCESS_PIN_HEADER = 'x-service-access-pin'
